import { render, staticRenderFns } from "./DepositReceive.vue?vue&type=template&id=80c4c48a&scoped=true"
import script from "./DepositReceive.vue?vue&type=script&lang=js"
export * from "./DepositReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c4c48a",
  null
  
)

export default component.exports